import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createUseStyles as originalCreateUseStyles } from 'react-jss';
import { theming, RAMBLER_UI_DISPLAY_NAME_PREFIX } from './jss';
import uuid from '../utils/uuid';
export default function createUseStyles(styles) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return originalCreateUseStyles(styles, _defineProperty({
    theming: theming
  }, RAMBLER_UI_DISPLAY_NAME_PREFIX, "".concat(options.name || uuid(), "-")));
}